import { UseFormReturn, Controller } from "react-hook-form";
import Select from "@/components/Select";
import TextField from "@/components/TextField";
import Button from "@/components/Button";
import classNames from "classnames";
import { NumberFormatBase } from "react-number-format";
import { currencyFormatter } from "@/lib/currencyHelpers";

interface EnumOption {
  name: string;
  description: string;
}

interface EventSpendFormData {
  strategicFunding: string;
  estimatedExpenses: number;
  sponsorshipAsk: number;
}

interface EditEventSpendCardProps {
  form: UseFormReturn<EventSpendFormData>;
  onSubmit: (formData: EventSpendFormData) => void;
  onCancel: () => void;
  isSubmitting: boolean;
  enumOptionsData?: {
    strategicFundingOptions?: {
      enumValues: EnumOption[];
    };
  };
}

export default function EditEventSpendCard({
  form,
  onSubmit,
  onCancel,
  isSubmitting,
  enumOptionsData
}: EditEventSpendCardProps) {
  return (
    <div className="space-y-6 w-full">
      <div className="col-span-full">
        <Controller
          control={form.control}
          name="strategicFunding"
          render={({ field }) => (
            <Select
              label="Strategic Funding"
              options={
                enumOptionsData?.strategicFundingOptions?.enumValues?.map((option) => ({
                  label: option.description,
                  value: option.name
                })) || []
              }
              value={field.value}
              onSelect={(value: string) => field.onChange(value)}
            />
          )}
        />
      </div>
      <div className="col-span-full">
        <Controller
          control={form.control}
          name="estimatedExpenses"
          render={({ field }) => (
            <NumberFormatBase
              label="Estimated Expenses"
              className="w-full"
              value={field.value || 0}
              format={(value) => `$${currencyFormatter(value)}`}
              customInput={TextField}
              onValueChange={(values) => {
                field.onChange(values.floatValue || 0);
              }}
            />
          )}
        />
      </div>
      <div className="col-span-full">
        <Controller
          control={form.control}
          name="sponsorshipAsk"
          render={({ field }) => (
            <NumberFormatBase
              label="Sponsorship Ask"
              className="w-full"
              value={field.value || 0}
              format={(value) => `$${currencyFormatter(value)}`}
              customInput={TextField}
              onValueChange={(values) => {
                field.onChange(values.floatValue || 0);
              }}
            />
          )}
        />
      </div>
      <div className="flex justify-end gap-2 mt-4">
        <Button variant="outlined" disabled={isSubmitting} onClick={onCancel}>
          Cancel
        </Button>
        <Button
          iconClassName={classNames(isSubmitting && "animate-spin w-6 h-6 !block")}
          disabled={isSubmitting}
          icon={isSubmitting ? "progress_activity" : undefined}
          onClick={() => onSubmit(form.getValues())}
        >
          Save
        </Button>
      </div>
    </div>
  );
}
